export const OPERATIONAL_MESSAGE_ENGLISH_TEXT_SEPARATOR = "EN: ";
